<template>
  <Block :title="$t('certificate')" class="info-block">
    <md-field>
      <md-field-item :title="$t('type')" :addon="certificate.certificateType && certificate.certificateType.description" />
      <md-field-item :title="$t('id_no')" :addon="certificate.idNo" />
    </md-field>
  </Block>
</template>

<script>
import Block from '@/components/Block'
import { Field, FieldItem } from 'mand-mobile'
// 证件信息组件
export default {
  name: 'Certificate',
  components: {
    Block,
    [Field.name]: Field,
    [FieldItem.name]: FieldItem
  },
  props: {
    certificate: {
      type: Object,
      default: null
    }
  }
}
</script>

<style lang='scss'>
.info-block {
  .flash-block__content {
    .flash-block_body {
      padding: 0;
    }
  }
}
</style>
